import { LinkedIn } from '@mui/icons-material';
import { FcPhone } from 'react-icons/fc';
import { RiWhatsappFill } from 'react-icons/ri';
import gmailIcon from '../../assets/gmailLogo.png'
import { motion } from "framer-motion";
import { useMediaQuery } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { useCreateLinksClicksMutation, useCreateLinksImpressionsMutation } from '../../helpers/StatisticsApi';

const Footer = () => {

    const isDesktop = useMediaQuery("(min-width: 1024px)");
    const myRef = useRef(null);


    let icons = [
        {
            icon: <RiWhatsappFill className='h-[23px] text-green-500' />,
            link: 'https://wa.me/+923250719500 ',
            title: 'whatsapp'
        },

        {
            icon: <LinkedIn sx={{ fontSize: '23px', color: '#1976d2' }} />,
            link: 'https://www.linkedin.com/in/code-zone-2222a5260',
            title: 'linkedin'

        },
        {
            icon: <img src={gmailIcon} className='h-[23px]' alt='img' />,
            link: 'mailto:codezone546@gmail.com',
            title: 'mail'

        },
        {
            icon: <FcPhone className='h-[23px]' />,
            link: 'tel:+92(325) 071-9500',
            title: 'phone'
        },
    ]

    const [none, setnone] = useState(true)

    const [createImpression, res] = useCreateLinksImpressionsMutation()
    const [createClicks, resClicks] = useCreateLinksClicksMutation()

    useEffect(() => {
        window.addEventListener("scroll", () => {
            if (window.pageYOffset > 1200) {
                setnone(false)
            } else {
                setnone(true)
            }
        });

    }, []);

    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            const [entry] = entries;
            if (entry.isIntersecting) {
                // call your function here
                if (localStorage.getItem('areaDetails')) {
                    const locationObj = JSON.parse(localStorage.getItem('areaDetails'));

                    const userId = locationObj.userId;
                    const countryName = locationObj.countryName;
                    const city = locationObj.city;
                    const postal = locationObj.postal;
                    const ip = locationObj.ip;
                    const region = locationObj.region;
                    const capital = locationObj.country_capital;
                    const deviceType = locationObj.deviceType;
                    const latitude = locationObj.latitude;
                    const longitude = locationObj.longitude;

                    createImpression({ userId, countryName, city, postal, ip, region, capital, deviceType, latitude, longitude })
                }
            }
        });
        observer.observe(myRef.current);
        return () => {
            observer.disconnect();
        };
    }, []);


    const handleClick = (e, item) => {

        console.log(item)

        window.open(item.link)

        if (localStorage.getItem('areaDetails')) {
            const locationObj = JSON.parse(localStorage.getItem('areaDetails'));
            const userId = locationObj.userId;
            const countryName = locationObj.countryName;
            const city = locationObj.city;
            const postal = locationObj.postal;
            const ip = locationObj.ip;
            const region = locationObj.region;
            const capital = locationObj.country_capital;
            const deviceType = locationObj.deviceType;
            const latitude = locationObj.latitude;
            const longitude = locationObj.longitude;

            let title = item.title

            createClicks({ userId, countryName, city, postal, title, ip, region, capital, deviceType, latitude, longitude })

        }

    }


    return (
        <div className={`bg-gradient-to-bl from-gray-900 to-gray-800 `} ref={myRef}>

            <div className='max-w-screen-2xl mx-auto px-5 pt-4'>

                <div className='grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-3'>

                    <div className='flex justify-center lg:justify-start cursor-pointer' onClick={() => window.scrollTo(0, 0)}>
                        {isDesktop && !none ? (
                            <motion.div
                                whileInView={{ x: 60 }} // slide 50px to the right
                                transition={{ duration: 0.7 }} // animation duration in seconds
                                className='flex gap-2 items-center'
                            >
                                <div className=' h-[35px] md:h-[45px] hover:scale-90 duration-700 w-[35px] md:w-[45px] opacity-90 border-[4px] md:border-[5px] border-white rounded-full flex justify-center items-center'>
                                    <h1 className=' text-[14px] md:text-[18px] font-semibold text-white'>
                                        CZ
                                    </h1>
                                </div>
                                <p className="text-gray-100 text-sm">Code<span className="font-bold text-green-500">Zone</span></p>
                            </motion.div>
                        ) : (
                            <div className='flex gap-2 items-center'>
                                <div className=' h-[35px] md:h-[45px] hover:scale-90 duration-700 w-[35px] md:w-[45px] opacity-90 border-[4px] md:border-[5px] border-white rounded-full flex justify-center items-center'>
                                    <h1 className=' text-[14px] md:text-[18px] font-semibold text-white'>
                                        CZ
                                    </h1>
                                </div>
                                <p className="text-gray-100 text-sm">Code<span className="font-bold text-green-500">Zone</span></p>
                            </div>
                        )}
                    </div>

                    <div className=' flex justify-center gap-3'>
                        {icons.map((item, i) => {
                            return <div
                                key={i}
                                onClick={(e) => handleClick(e, item)}
                                className={'w-[40px] relative group h-[40px] rounded-full flex justify-center items-center bg-white cursor-pointer hover:scale-90 duration-700 hover:white-shadow'}
                            >
                                {item.icon}
                                <span id='k' className="group-hover:ping-once absolute rounded-full bg-slate-500 -z-20 duration-[800ms] opacity-75"></span>
                            </div>
                        })}

                    </div>
                    <div onClick={() => window.open('mailto:codezone546@gmail.com')} className='flex items-center group justify-center lg:justify-end gap-2 cursor-pointer'>
                        <img src={gmailIcon} className='h-[30px] hover:shake ' alt='img' />
                        <div className='flex items-center gap-2 divide-x-2'>
                            <h3 className='text-white font-bold text-sm'>Email Us</h3>
                            <h4 className='text-white text-[15px] pl-2'>code<span className='text-green-500'>zone</span>546@gmail.com</h4>
                        </div>
                    </div>
                </div>
                <div className='pt-4 pb-1'>
                    <h5 className='text-center font-semibold text-white text-[15px] sm:text-xs '>© 2023 All Rights Reserved By  CodeZone</h5>
                </div>
            </div>
        </div>
    )
}

export default Footer

